"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
/**
 * @param  {string} subscriptionUid uid del suscriptor
 * @returns boolean
 */
const isActiveSubscriptor = async (firestore, uid) => {
    try {
        const subscriptions = (0, firestore_1.query)((0, firestore_1.collection)(firestore, `user/${uid}/subscriptions`), (0, firestore_1.where)("active", "==", true));
        const querySnapshot = await (0, firestore_1.getDocs)(subscriptions);
        return !querySnapshot.empty;
    }
    catch (err) {
        throw new Error(`Error getting active subscription, error: ${err}`);
    }
};
exports.default = isActiveSubscriptor;
